import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function BatchesPage() {
  return <InstituteCrudPage config={entityConfigs['batches']} />;
}
